import React, { useReducer, useRef } from 'react';

import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { availabilityStatus } from './availability_logic';
import { AvailabilityCalendar, initializeAvailabilityCalendar } from './calendar_logic';
import { titleize } from './filters_panel';
import { IUnavailability } from './types';

type ManagementCalendarProps = {
  unavailabilities: IUnavailability[];
};

export const ManagementCalendar: React.FC<ManagementCalendarProps> = ({ unavailabilities }) => {
  const calendarRef = useRef<AvailabilityCalendar>(initializeAvailabilityCalendar());
  const [, forceRender] = useReducer((value: number) => value + 1, 0);
  const calendar = calendarRef.current;

  const statusForEntry = (entry: { value: { toISODate: () => string | null } }) => {
    const date = entry.value.toISODate();
    if (!date) {
      return 'full';
    }
    return availabilityStatus(unavailabilities, { date: new Date(`${date}T00:00:00.000Z`) });
  };

  return (
    <div className="panel">
      <div className="legend">
        <div className="legend-entry availability-full">Full Availability</div>
        <div className="legend-entry availability-none">No Availability</div>
      </div>

      <div className="calendar-info">
        <a
          href="#"
          className="calendar-prev btn btn-link"
          onClick={(event) => {
            event.preventDefault();
            calendar.prev();
            forceRender();
          }}
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </a>
        <a
          href="#"
          className="calendar-next btn btn-link"
          onClick={(event) => {
            event.preventDefault();
            calendar.next();
            forceRender();
          }}
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </a>
        <div className="calendar-title">{calendar.title()}</div>
      </div>

      <div className="table-responsive">
        <table className="table">
          <thead className="calendar-group">
            <tr>
              {calendar.sections.map((section) => (
                <th key={section.kind} className="calendar-section">
                  {titleize(section.kind)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {calendar.chunks.map((chunk, chunkIndex) => (
              <tr key={chunkIndex} className="calendar-group">
                {chunk.map((entry, entryIndex) => (
                  <td key={entry?.key ?? `empty-${chunkIndex}-${entryIndex}`} className="calendar-cell">
                    {entry && (
                      <>
                        <div className="calendar-cell-date">{entry.date}</div>
                        <div className={`calendar-cell-availability availability-${statusForEntry(entry)}`} />
                      </>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
